<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.0006 9.92858H19.5721V14.2143H21.0006V9.92858Z"/>
    <path d="M15.6434 9.92858H17.072V14.2143H15.6434V9.92858Z"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0006 6L7.4292 9.57143V22.4286H11.7149V26L15.2863 22.4286H18.1435L24.5721 16V6H11.0006ZM23.1435 15.2857L20.2863 18.1429H17.4292L14.9292 20.6429V18.1429H11.7149V7.42857H23.1435V15.2857Z"/>
  </svg>
</template>